// extracted by mini-css-extract-plugin
export default {"alert":"CancelHoldRequest_alert__CYV0M"};